import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import React from 'react';
import styled from 'react-emotion';
import { SelectDropdown as BaseDropdown } from '../../../Select';
import stripCategoryId from '@jetshop/core/components/Filters/utils/stripCategoryId';
const SelectDropdown = styled(BaseDropdown) `
  ${({ theme }) => theme.below.sm} {
    border-top: none;
    margin: 0;
    .toggleSelect {
      border-top: 0;
    }
  }
`;
// Maps over list filters and returns a set of Downshift-powered dropdowns
const MultiListFlyouts = ({ filters, className }) => {
    const listFilters = filters.filter(filter => filter.__typename === 'MultiListFilter');
    if (listFilters.length < 1)
        return null;
    return (React.createElement(ErrorBoundary, { component: PassThrough },
        React.createElement(FilterContext.Consumer, null, filterProps => listFilters.map(filter => {
            const selectedFilter = filterProps.activeFilters.multiListFilters.find(item => item.id === stripCategoryId(filter.id) || item.id === filter.id);
            return (React.createElement(React.Fragment, { key: filter.id }, filter.lists.map((list, index) => {
                const selectedItem = selectedFilter && selectedFilter.values[index]
                    ? { value: selectedFilter.values[index] }
                    : null;
                return (React.createElement(SelectDropdown, { key: list.name, items: list.items, title: list.name, selectedItem: selectedItem, disabled: list.items.length === 0, showClearButton: true, onChange: (e) => {
                        filterProps.applyMultiFilter(filter.id, e.value, index);
                    }, className: className }));
            })));
        }))));
};
export default MultiListFlyouts;
//# sourceMappingURL=MultiListFlyouts.js.map